import { render, staticRenderFns } from "./SelectMultiMunicipio.vue?vue&type=template&id=253cfd8a"
import script from "./SelectMultiMunicipio.vue?vue&type=script&lang=js"
export * from "./SelectMultiMunicipio.vue?vue&type=script&lang=js"
import style0 from "./SelectMultiMunicipio.vue?vue&type=style&index=0&id=253cfd8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports